import { useQuery } from "@blitzjs/rpc"
import React from "react"
import { z } from "zod"
import { FormSpy } from "react-final-form"
import Grid from "@mui/material/Grid"

import getLanguages from "../../languages/queries/getLanguages"
import Autocomplete from "../../core/components/Autocomplete"
import getGeographies from "../../geographies/queries/getGeographies"
import Form, { FormProps } from "../../core/components/Form"
import LabeledTextField from "../../core/components/LabeledTextField"

type CopyDialogFormProps<S extends z.ZodType<any, any>> = Omit<FormProps<S>, "onChange"> & {
  onChange: (e: { [field: string]: any }) => void
}

export default function CopyDialogForm<S extends z.ZodType<any, any>>({
  onChange,
  ...props
}: CopyDialogFormProps<S>) {
  const [geographies] = useQuery(getGeographies, { orderBy: { name: "asc" } })
  const [languages] = useQuery(getLanguages, { orderBy: { name: "asc" } })

  return (
    <Form<S> id="copy-dialog-form" {...props}>
      <Grid container spacing={1}>
        <Grid item xs={3}>
          <Autocomplete
            name="geographyId"
            label="Geography"
            options={geographies}
            getOptionLabel={(option: any) => option.name}
          />
        </Grid>
        <Grid item xs={3}>
          <Autocomplete
            name="languageId"
            label="Language"
            options={languages}
            getOptionLabel={(option: any) => option.name}
          />
        </Grid>
        <Grid item xs={6}>
          <LabeledTextField name="name" label="Pipeline name" />
        </Grid>
      </Grid>
      <FormSpy subscription={{ values: true }} onChange={(e) => onChange(e.values)} />
    </Form>
  )
}
